import { defineMessages } from 'react-intl';

const translations = {
  formStep: {
    success: {
      description: {
        id: 'pages.profile.form.steps.success.description',
        defaultMessage:
          "The authenticator app is now connected to your account. From now on you'll need to sign in with your email address, password and the Authenticator app.",
        description: 'description of the success step in the 2fa form',
      },
    },
  },
  formActions: {
    finish: {
      id: 'formActions.finish',
      defaultMessage: 'Finish',
      description: 'label of the finish button',
    },
  },
};

export default defineMessages(translations);
